// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"649":"476a7a56","693":"d0c8c4f0"}[chunkId] + ".chunk.css";
};